import React, { useState, useRef, useEffect, useCallback } from "react";
// import Config from "../../config";
import { sendEmailVerificationCode, loginByThird } from "./service";
import styles from './login.module.css'
// import type { Dict, FBLoginRes } from "@/app/lib/definitions";
import { getFromLocalStorage, setToLocalStorage } from "../../common/util";
import { ChannelCacheKey } from "../../config";

function Step0(
    {
        initialValue, passEmail, show, containerShow, userReadyState, isLogin, loginCallback, cancelLogin
    }: {
        initialValue: string,
        passEmail: (v: string) => void,
        show: boolean,
        containerShow: boolean,
        userReadyState: boolean,
        isLogin: boolean,
        loginCallback: (data: any) => void,
        cancelLogin: () => void
    }) {
    const [email, setEmail] = useState(initialValue)
    const [showErrTip, toggleErrTip] = useState(false)
    const [errContent, setErrContent] = useState('')
    const [ageChecked, toggleAgeChecked] = useState(false)
    const [gLAutoPrompt, toggleGLAutoPrompt] = useState('false')
    // const [showFLBtn, toggleFLBtn] = useState(false)
    const submitFlag = useRef(false)
    const loadGLFlag = useRef(false)
    // const loadFLFlag = useRef(false)
    const loadGL = useCallback(() => {
        // if (!loadGLFlag.current) {
        //     loadGLFlag.current = true
        //     const resource = document.createElement('script')
        //     resource.src = 'https://accounts.google.com/gsi/client?hl=en_US'
        //     document.head.appendChild(resource)
        // }
    }, [])

    // useEffect(() => {
    //     if (!loadFLFlag.current) {
    //         loadFLFlag.current = true

    //         window.fbAsyncInit = function () {
    //             window.FB.init({
    //                 appId: '2516532718765804',
    //                 cookie: true,
    //                 xfbml: true,
    //                 version: 'v24.0'
    //             })
    //             toggleFLBtn(true)
    //         }

    //         const resource = document.createElement('script')
    //         resource.id = 'facebook-jssdk'
    //         resource.src = 'https://connect.facebook.net/en_US/sdk.js'
    //         document.head.appendChild(resource)
    //     }
    // }, [])

    useEffect(() => {
        if (userReadyState) {
            if (!isLogin && !getFromLocalStorage('_glp')) {
                setToLocalStorage('_glp', '1')
                toggleGLAutoPrompt('true')
            }
            loadGL()
        }
    }, [userReadyState, isLogin, loadGL])

    useEffect(() => {
        if (!containerShow) {
            setEmail('')
            toggleErrTip(false)
            toggleAgeChecked(false)
        }
    }, [containerShow])

    const inputEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target
        setEmail(value)
    }

    const submit = () => {
        // window.ST && window.ST.webTJ && window.ST.webTJ.reportEvent({
        //     category: 'login_email',
        //     label: 'login_email',
        //     action: 'click',
        //     value: encodeURIComponent(JSON.stringify({
        //         domain: window.location.host,
        //         pid: window[ChannelCacheKey]
        //     }))
        // })
        toggleErrTip(false)
        const value = (email || '').trim()
        if (!value) {
            return setEmail('')
        }
        if (!ageChecked) {
            setErrContent("Please check the box below to confirm that you are over 18 years old.")
            toggleErrTip(true)
            return
        }
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
            setErrContent("Invalid email")
            toggleErrTip(true)
            return
        }
        if (submitFlag.current) {
            return
        }
        submitFlag.current = true
        sendEmailVerificationCode(value).then(() => {
            passEmail(value)
        }).catch((e: { message: React.SetStateAction<string>; }) => {
            setErrContent(e.message)
            toggleErrTip(true)
        }).finally(() => {
            submitFlag.current = false
        })
    }

    const enterEmail = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            submit()
        }
    }

    // const loginByFacebook = () => {
    //     window.ST && window.ST.webTJ && window.ST.webTJ.reportEvent({
    //         category: 'login_facebook',
    //         label: 'login_facebook',
    //         action: 'click',
    //         value: encodeURIComponent(JSON.stringify({
    //             domain: window.location.host,
    //             pid: window[ChannelCacheKey]
    //         }))
    //     })
    //     window.FB.login(function (response: FBLoginRes) {
    //         // console.log(response)
    //         if (response.status === 'connected') {
    //             loginByThird(response.authResponse.accessToken, 5)
    //                 .then(loginCallback)
    //                 .catch((e: Error) => {
    //                     console.error(e)
    //                     cancelLogin()
    //                 })
    //         }
    //     }, { scope: 'public_profile,email' })
    // }

    return <div className={show ? styles['login-step-layout'] : styles['login-step-hidden']}>
        <h2 className={styles['login-main-title']}>Welcome to Yoomet</h2>
        <div className={styles['login-split-wapper']}>
            <div className={styles['login-split-line']}></div>
            <span className={styles['login-split-txt']}>Or use</span>
            <div className={styles['login-split-line']}></div>
        </div>
        <div className={styles['login-form-row']}>
            <input className={styles['login-input']} placeholder="Enter your Email" value={email} onChange={inputEmail} onKeyDown={enterEmail}></input>
        </div>
        <div className={styles['login-btn-row']}>
            {
                showErrTip && <div className={styles['err-tip-wrapper']}>
                    <p className={styles['err-tip-content']}>{errContent}</p>
                </div>
            }
            <button className={styles['login-main-btn']} onClick={submit}>Sign in</button>
        </div>
        <p className={styles['age-tip']}>
            <i className={ageChecked ? styles['age-checked'] : styles['age-check']} onClick={() => toggleAgeChecked(!ageChecked)}></i>
            <span>I confirm that I am over 18 years old</span>
        </p>
        <div className={styles['login-tip-wrapper']}>
            <p className={styles['login-tip']}>
                <span>By continuing, I agree to Yoomet AI's </span>
                <a target="_blank" href="/Privacy_Policy.html">
                    <span className={styles['login-tip-link']}>Privacy Policy</span>
                </a>
                <span>and</span>
                <a target="_blank" href="/Terms_of_Service.html">
                    <span className={styles['login-tip-link']}>Terms Of Service</span>
                </a>
            </p>
        </div>
    </div>
}

export default Step0